export default __webpack_public_path__ + "static/media/puzzle-diagram-new.dd38d902.png";